import { object, ObjectSchema, TypedForm, array } from 'libs/form';
import {
  IdentityDocumentFormType as BaseIdentityDocumentFormType,
  identityDocumentSchema as baseIdentityDocumentSchema,
} from 'modules/client/common/forms/identityDocumentForm';
import { localFileScheme } from 'modules/client/common/helpers';

import { LocalFileEntity } from '../types';

export interface IdentityDocumentFormType {
  identityDocument: BaseIdentityDocumentFormType['identityDocument'] & {
    files?: LocalFileEntity[];
  };
}

export const identityDocumentSchema: ObjectSchema<IdentityDocumentFormType> =
  baseIdentityDocumentSchema.concat(
    object({
      identityDocument: object({
        files: array().of(localFileScheme.required()),
      }),
    })
  );

export const getIdentityDocumentSchema = (
  isRequiredFiles: boolean
): ObjectSchema<IdentityDocumentFormType> =>
  baseIdentityDocumentSchema.concat(
    object({
      identityDocument: object({
        files: array()
          .of(localFileScheme.required())
          .when({
            is: () => isRequiredFiles,
            then: (schema) => schema.required().min(1),
          }),
      }),
    })
  );

export const { Field, Form, useFormContext, Submit } =
  TypedForm<IdentityDocumentFormType>();
